import React, { useContext, useEffect } from 'react'
import { useLazyQuery, NetworkStatus, gql } from '@apollo/client'
import { Paper, Typography } from '@material-ui/core'
import { CartChangeFiltersContext } from '../../../../context/CartChangeFiltersContext'
import ChartDonut from '../../../../components/charts/ChartDonut'
import ChartDonutSkeleton from '../../../../components/skeletons/ChartDonutSkeleton'
import { ChartColumnThemes } from '../../../../components/charts/types/ChartColumn'
import { formatNumber } from '../../../../utils/Helpers'

const CART_CHANGE_OPENNED = 'O usuário acessou a dialog de mudança de cesta'
const CART_CHANGE_UNDEFINED = 'O usuário não tomou nenhuma decisão'
const GET_ACCEPTED_DISMISSED_ABANDON = gql`
  query GetAcceptedDismissedAbandon($filters: EventCartChangeFilter) {
    eventCartChangeAggs(
      filters: $filters,
      index: "eventos-fapp-cart-change-*", 
      size: 0,
      aggs: {
        pharmacies: {
          terms: {
            field: "message.keyword",
            size: 3
          }
        }
      }
    ) {
      aggregations
    }
  }
`

interface Bucket {
  key: string
  doc_count: number
}
const AcceptanceRefuseAbandon = (): JSX.Element => {
  const { filters } = useContext(CartChangeFiltersContext)
  const [getData, { loading, error, data, networkStatus }] = useLazyQuery(
    GET_ACCEPTED_DISMISSED_ABANDON, {
      notifyOnNetworkStatusChange: true
    }
  )

  useEffect(() => {
    getData({
      variables: { filters }
    })
  }, [filters])

  if (networkStatus === NetworkStatus.refetch) return <ChartDonutSkeleton />
  if (loading || !data) return <ChartDonutSkeleton />
  if (error) return <p>Error :(</p>
  if (!data.eventCartChangeAggs.aggregations) return <p>No data found</p>

  try {
    const { buckets } = data.eventCartChangeAggs.aggregations.pharmacies

    if (buckets.length <= 0) return <p>No data found</p>

    const labels: Array<string> = []
    const series: Array<number> = []
    const opennedBuckets = buckets.filter((bucket: Bucket) => bucket.key === CART_CHANGE_OPENNED)
    const totalCartChangeOpenened = opennedBuckets.length > 0 ? opennedBuckets[0].doc_count : 0

    const totalCartChangeOthers = buckets
      .filter((bucket: Bucket) => bucket.key !== CART_CHANGE_OPENNED)
      .reduce((acc: Bucket, cur: Bucket) => acc.doc_count + cur.doc_count)

    buckets.map((bucket: Bucket) => {
      if (bucket.key === CART_CHANGE_OPENNED) {
        labels.push(CART_CHANGE_UNDEFINED)
        return series.push(totalCartChangeOpenened - totalCartChangeOthers)
      }
      labels.push(bucket.key)
      return series.push(bucket.doc_count)
    })

    const options = {
      chart: {
        id: 'acceptance-refuse-abandon'
      },
      labels,
      yaxis: {
        show: false
      },
      fill: {
        opacity: 1
      },
      legend: {
        formatter: function (seriesName: string, opts: any) {
          let total = 0
          opts.w.globals.series.map((serie: any) => {
            total += serie
          })

          return [' ', seriesName, ' - ', formatNumber((opts.w.globals.series[opts.seriesIndex] / total) * 100, 2), '%']
        },
        width: 275,
        height: 300
      },
      dataLabels: {
        formatter: function (value: number) {
          return `${formatNumber(value, 2)}%`
        }
      },
      tooltip: {
        y: {
          formatter: function (value: number) {
            return formatNumber(value, 0)
          }
        }
      }
    }

    if (!data) return <p>No data found</p>

    return <Paper elevation={2}>
      <Typography
        paragraph
        style={{ paddingLeft: '20px', paddingTop: '20px' }}
      >
        Percentual de aceitação, recusa e sem decisão sobre a mudança de cesta
      </Typography>
      <ChartDonut options={options} series={series} theme={ChartColumnThemes.blue} type="donut" />
    </Paper>
  } catch {
    return <p>No data found</p>
  }
}

export default AcceptanceRefuseAbandon
